import { Theme, createStyles } from '@material-ui/core/styles';

export const menuStyles = (theme: Theme) => {
  return createStyles({
    list: {},
    paper: {
      border: '1px solid rgba(0, 0, 0, 0.12)', // MuiPaper-outline
      borderRadius: 3, // current radius
    },
  });
};
